<div class="editable-card-container">
  <div class="editable-card-header">
    <div class="editable-card-title">{{ titleText() }}</div>
    <div class="editable-card-actions">
      @if (isEditing()) {
        <lib-button [type]="ButtonType.tertiary" (buttonClick)="cancelClicked()" [disabled]="isSaving()" i18n>
          Cancel
        </lib-button>
        <lib-button [type]="ButtonType.primary" [loading]="isSaving()" (buttonClick)="saveClicked()" i18n>
          Save
        </lib-button>
      } @else {
        <lib-button
          [type]="ButtonType.tertiary"
          [leadingIconName]="'edit-square'"
          (buttonClick)="isEditing.set(true)"
          i18n>
          Edit
        </lib-button>
      }
    </div>
  </div>
  <ng-content></ng-content>
</div>
